import Button from "../components/Button";
import Card from "../components/Card";
import ToasterExample from "../components/ToasterExample";

const UIShowRoom = () => {
  return (
    <div className="ui-showroom-view">
      <h1>UI Showroom</h1>
      <p>Explore the various UI components available in the library.</p>

      <div className="default-background">
        <h2>Default</h2>

        <p>Buttons on the default background.</p>

        <Button buttonStyle="flat" intent="primary" background="default">
          Click me!
        </Button>
        <Button buttonStyle="flat" intent="success" background="default">
          Click me!
        </Button>
        <Button buttonStyle="flat" intent="danger" background="default">
          Click me!
        </Button>
        <Button buttonStyle="outline" intent="primary" background="default">
          Click me!
        </Button>
        <Button buttonStyle="outline" intent="success" background="default">
          Click me!
        </Button>
        <Button buttonStyle="outline" intent="danger" background="default">
          Click me!
        </Button>
      </div>

      <div className="card-background">
        <h2>Card</h2>
        <p>Buttons with card as background.</p>
        <Card>
          <Button buttonStyle="flat" intent="primary" background="card">
            Click me!
          </Button>
          <Button buttonStyle="flat" intent="success" background="card">
            Click me!
          </Button>
          <Button buttonStyle="flat" intent="danger" background="card">
            Click me!
          </Button>
          <Button buttonStyle="outline" intent="primary" background="card">
            Click me!
          </Button>
          <Button buttonStyle="outline" intent="success" background="card">
            Click me!
          </Button>
          <Button buttonStyle="outline" intent="danger" background="card">
            Click me!
          </Button>
        </Card>
      </div>

      <div className="toaster-section">
        <h2>Toaster</h2>
        <p>Test the toaster notifications with different types and features.</p>
        <ToasterExample />
      </div>
    </div>
  );
};
export default UIShowRoom;
